import React from "react";
import Logo from "../assets/icons/logo.svg";
import PrimaryBtn from "../components/partials/btn";
import Img from "../assets/images/image.png";
import { DetailType } from "../utils/types";
import Mail from "../assets/icons/mail.svg";
import Zap from "../assets/icons/zap.svg";
import Chart from "../assets/icons/bar-chart-2.svg";
import Half from "../assets/images/Mockup wrap.png";
import ArrowRight from "../assets/icons/arrow-right.svg";
import { useNavigate } from "react-router-dom";

const Home = () => {
  return (
    <div>
      <HeroSection />
      <DetailSection />
      <TutorialSection />
      <Footer />
    </div>
  );
};

const HeroSection = () => {
  const navigate = useNavigate();
  return (
    <section className="lg:h-screen h-[60vh] relative w-full bg-[#000000CC]">
      <video
        className="absolute top-0 left-0 w-full h-full object-cover"
        autoPlay
        loop
        muted
      >
        <source src={require("../assets/images/herobg.mp4")} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="absolute top-0 left-0 w-full h-full bg-black/70"></div>
      <div className="section-container h-full flex justify-start items-center relative">
        <img src={Logo} alt="" className="absolute top-6" />
        <div>
          <h1 className="lg:text-6xl text-4xl font-bold text-white lg:leading-[64px] tracking-[-2]">
            Data System <span className="text-primary">Maturity</span> <br />
            Assessment Tool
          </h1>
          <p className="mt-6 lg:text-xl text-base font-normal text-white max-w-3xl">
            Providing stakeholders with both quantifiable and qualitative
            results regarding the quality and effectiveness of data collection
            tools, data systems, and flows.
          </p>
          <div className="mt-8">
            <PrimaryBtn
              onClick={() => navigate("/dashboard")}
              text="Access Dashboard"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

const DetailSection = () => {
  const Arr: DetailType[] = [
    {
      icon: Mail,
      title: "Share team inboxes",
      desc: "Whether you have a team of 2 or 200, our shared team inboxes keep everyone on the same page and in the loop.",
    },
    {
      icon: Zap,
      title: "Deliver instant answers",
      desc: "An all-in-one customer service platform that helps you balance everything your customers need to be happy.",
    },
    {
      icon: Chart,
      title: "Manage your team with reports",
      desc: "Measure what matters with Untitled’s easy-to-use reports. You can filter, export, and drilldown on the data in a couple clicks.",
    },
  ];
  return (
    <section className="w-full py-20 bg-white">
      <div className="section-container">
        <p className="text-base font-semibold text-primary text-center">
          Easy Assessmment
        </p>
        <h3 className="lg:text-4xl text-2xl mt-4 font-semibold text-sec text-center">
          An all-in-one tool for your entire team
        </h3>
        <p className="mt-4 lg:text-xl text-base font-normal text-[#667085] max-w-xl mx-auto text-center">
          No more ping-ponging between emails, spreadsheets, and other apps.
          Bring everything together in one place.{" "}
        </p>
        <img src={Img} alt="" className="mx-auto mt-8" />
      </div>
      <div className="bg-[#F9FAFB] py-16 mt-8 w-full">
        <div className=" section-container grid lg:grid-cols-3 gap-5">
          {Arr?.map((it, i) => (
            <div key={i} className="w-full">
              <div
                style={{
                  border: "8px solid #F9F5FF",
                }}
                className="size-12 mx-auto bg-[#D7E2EC] rounded-full flex justify-center items-center"
              >
                <img src={it?.icon} alt="" className="" />
              </div>
              <h5 className="text-xl font-medium text-sec text-center">
                {it?.title}
              </h5>
              <p className="mt-1 text-base text-[#667085] text-center">
                {it?.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const TutorialSection = () => {
  const Arr = [
    {
      active: true,
      title: "Share team inboxes",
      desc: "Whether you have a team of 2 or 200, our shared team inboxes keep everyone on the same page and in the loop in the hiring process.",
    },
    {
      title: "Deliver instant follow-ups",
      desc: "An all-in-one hiring platform that helps you balance everything your candidates need to be happy and comfortable throughout the process.",
    },
    {
      title: "Manage your team with reports",
      desc: "Measure what matters with Untitled’s easy-to-use reports. You can filter, export, and drilldown on the data in a couple clicks.",
    },
  ];
  return (
    <section className="w-full relative py-20 bg-white">
      <img
        src={Half}
        alt=""
        className=" right-0 top-56 absolute hidden lg:block"
      />
      <div className="section-container">
        <p className="text-base font-semibold text-primary">
          Achieve Desired Output
        </p>
        <h3 className="lg:text-4xl text-2xl mt-4 font-semibold text-sec">
          A seamless experience for organisations
        </h3>
        <p className="mt-4 lg:text-xl text-base font-normal text-[#667085]">
          Treat candidates with a rich careers site and a wonderful application
          process.
        </p>
        <div className="mt-12 max-w-xl">
          {Arr?.map((it, i) => (
            <div
              key={i}
              style={{
                borderLeft: `4px solid ${it?.active ? "#2070B8" : "#F2F4F7"}`,
              }}
              className="h-40 pl-9 flex items-center"
            >
              <div>
                <h4 className="lg:text-xl text-base font-medium text-sec">
                  {it?.title}
                </h4>
                <p className="mt-2 text-base text-[#667085] font-normal">
                  {it?.desc}
                </p>
                <div className="mt-4 cursor-pointer flex items-center gap-4">
                  <h6 className="font-medium lg:text-base text-sm text-primary">
                    Learn More
                  </h6>
                  <img src={ArrowRight} alt="" className="" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const Footer = () => {
  const links = ["terms", "privacy", "cookies"];
  return (
    <section className="bg-[#1D2939]  pt-16 w-full">
      <div className="section-container border-b border-b-[#475467] pb-16 flex justify-center">
        <div>
          <h3 className="text-white text-center font-semibold lg:text-3xl text-xl">
            Let’s get started on something great
          </h3>
          <p className="lg:text-xl text-base mt-4 font-normal text-white text-center">
            Join over 4,000+ startups already growing with Untitled.
          </p>
          <div className="mt-5 flex justify-center">
            <PrimaryBtn text="Access dashboard" />
          </div>
        </div>
      </div>
      <div className="section-container flex items-center justify-between h-20">
        <h6 className="lg:text-base text-xs font-normal text-[#98A2B3]">
          © 2077 Untitled UI. All rights reserved.
        </h6>
        <div className="flex items-center gap-5">
          {links?.map((it, i) => (
            <h6
              key={i}
              className="text-base capitalize font-normal text-[#98A2B3]"
            >
              {it}
            </h6>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Home;
